export const GameStatus = (board, nCol, nRow, winCount) => {
  let i,
    j,
    status = 0,
    winningCoords = [];

  //Horizontal
  const horizontalWin = () => {
    for (j = 0; j < winCount; j++) {
      for (i = 0; i < nRow; i++) {
        if (
          board[i][j] &&
          board[i][j + 1] === board[i][j] &&
          board[i][j + 2] === board[i][j] &&
          board[i][j + 3] === board[i][j]
        ) {
          return {
            winner: board[i][j],
            winningCoords: [
              { x: i, y: j },
              { x: i, y: j + 1 },
              { x: i, y: j + 2 },
              { x: i, y: j + 3 },
            ],
          };
        }
      }
    }

    return {
      winner: 0,
      winningCoords: [],
    };
  };

  //Vertical
  const verticalWin = () => {
    for (j = 0; j < nCol; j++) {
      for (i = 0; i < winCount - 1; i++) {
        if (
          board[i][j] &&
          board[i + 1][j] === board[i][j] &&
          board[i + 2][j] === board[i][j] &&
          board[i + 3][j] === board[i][j]
        ) {
          return {
            winner: board[i][j],
            winningCoords: [
              { x: i, y: j },
              { x: i + 1, y: j },
              { x: i + 2, y: j },
              { x: i + 3, y: j },
            ],
          };
        }
      }
    }

    return {
      winner: 0,
      winningCoords: [],
    };
  };

  //Positive slope diagonal
  const positiveSlopeWin = () => {
    for (j = 0; j < winCount; j++) {
      for (i = 0; i < winCount - 1; i++) {
        if (
          board[i][j] &&
          board[i + 1][j + 1] === board[i][j] &&
          board[i + 2][j + 2] === board[i][j] &&
          board[i + 3][j + 3] === board[i][j]
        ) {
          return {
            winner: board[i][j],
            winningCoords: [
              { x: i, y: j },
              { x: i + 1, y: j + 1 },
              { x: i + 2, y: j + 2 },
              { x: i + 3, y: j + 3 },
            ],
          };
        }
      }
    }

    return {
      winner: 0,
      winningCoords: [],
    };
  };

  //Negative slope diagonal
  const negetiveSlopeWin = () => {
    for (j = 0; j < winCount; j++) {
      for (i = winCount - 1; i < nRow; i++) {
        if (
          board[i][j] &&
          board[i - 1][j + 1] === board[i][j] &&
          board[i - 2][j + 2] === board[i][j] &&
          board[i - 3][j + 3] === board[i][j]
        ) {
          return {
            winner: board[i][j],
            winningCoords: [
              { x: i, y: j },
              { x: i - 1, y: j + 1 },
              { x: i - 2, y: j + 2 },
              { x: i - 3, y: j + 3 },
            ],
          };
        }
      }
    }

    return {
      winner: 0,
      winningCoords: [],
    };
  };

  const isDraw = () => {
    for (let i = 0; i < nRow; i++) {
      for (let j = 0; j < nCol; j++) {
        if (!board[i][j]) return false;
      }
    }
    return true;
  };

  const horizontalWinner = horizontalWin(),
    verticalWinner = verticalWin(),
    primaryDiagonalWinner = positiveSlopeWin(),
    secondaryDiagonalWinner = negetiveSlopeWin();

  if (!status && horizontalWinner.winner) {
    status = horizontalWinner.winner;
    winningCoords = horizontalWinner.winningCoords;
  } else if (!status && verticalWinner.winner) {
    status = verticalWinner.winner;
    winningCoords = verticalWinner.winningCoords;
  } else if (!status && primaryDiagonalWinner.winner) {
    status = primaryDiagonalWinner.winner;
    winningCoords = primaryDiagonalWinner.winningCoords;
  } else if (!status && secondaryDiagonalWinner.winner) {
    status = secondaryDiagonalWinner.winner;
    winningCoords = secondaryDiagonalWinner.winningCoords;
  } else if (!status && isDraw()) {
    status = 3;
    winningCoords = [];
  }

  return {
    status,
    winningCoords,
  };
};
